/**
 * The max reviews count to display in a none formatted way.
 * @type {Number}
 */
export const MAX_REVIEW_COUNT = 1000;
